<template>
  <div id="fund">
    <v-container grid-list-md text-xs-center>
      <v-layout class="section text-xs-left my-4" row wrap style="width:960px; height:100%; overflow:hidden; margin:0 auto;">
        <!-- 左側區塊 -->
        <v-flex :class="device==='desktop' ? 'xs6 md6 lg6' : 'xs12 md12 lg12'" class="left-section">
          <v-layout class="section text-xs-left my-4" ref="one_section" row wrap>
            <template v-if="catelog">
              <v-flex :key="item.id" @click="selectCatelog(item)" id="left_section" lg6 md6 style="cursor: pointer" v-for="item in catelog.data" xs6>
                <v-card class="wow fadeInUp" flat>
                  <div class="image-container">
                    <img :src="`/cannan_api/images/${item.img}`" alt style="display:block;max-width:100%; margin:0 auto;">
                    <div class="after"></div>
                    <div :class="device==='desktop' ? 'headline' : 'body-1'" class="text">{{ item.title }}</div>
                  </div>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
        <!-- 右側區塊 -->
        <v-flex :class="device==='desktop' ? 'xs6 md6 lg6' : 'xs12 md12 lg12'" class="right-section wow fadeInRight">
          <template v-if="current_catelog">
            <v-layout class="fund_content section text-xs-left my-4" row>
              <v-flex lg12 md12 xs12>
                <v-card class="subheading" flat>
                  <div v-html="current_catelog.content">{{ current_catelog.content }}</div>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      heightData: 500,
      current_catelog: [],
      device: 'desktop'
    }
  },
  computed: mapGetters({ catelog: 'catelog' }),
  created() {
    this.fetchData()
    navigator.userAgent.indexOf('iPhone') > -1 ||
    navigator.userAgent.indexOf('Android') > -1
      ? (this.device = 'mobile')
      : (this.device = 'desktop')
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  },
  methods: {
    fetchData() {
      this.$store.dispatch('GetCatelog').then(() => {
        this.current_catelog = this.catelog.data[0]
      })
    },
    selectCatelog(catelog) {
      this.current_catelog = catelog
    }
  }
}
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  img {
    display: block;
    max-width: 100%;
    width: 300px;
    height: 150px;
    margin: 0 auto;
  }
  .after {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    display: none;
    display: block;
    background: rgba(0, 0, 0, 0.4);
  }
  .text {
    position: absolute;
    color: white;
    font-weight: 400;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.fund_content {
  word-break: break-all;
  padding: 30px 50px;
  overflow-y: auto;
  position: relative;
}

.section {
  display: flex;
  .left-section {
    // background: lavender;
    width: 100px;
    // height: 00px;
  }

  .right-section {
    margin: 30px auto;
    border: 2px solid #6d451b;
    // background: lightpink;
    flex: 1;
  }
}
</style>
